import React, { useContext, useState, useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import * as S from './AlarmMakeModal.style';
import { makeAlarm } from '../../../services/apis/CustomApi';
import { ACTIONS, DISPLAYS } from '../../../data/motion';
import { RootStoreContext } from '../../../App';
import { useForm, SubmitHandler } from 'react-hook-form';
import UserSelectDropdown from './UserSelectDropdown';
import CustomTimeInput from '../../../components/input/CustomTimeInput';
import CalendarInput from '../../../components/input/CalendarInput';

const date = new Date();
const formattedDate = date.toISOString().slice(0, 10);

function formatted(dateStr) {
	let parts = dateStr.split('-');
	let month = parts[1].padStart(2, '0');
	let day = parts[2].padStart(2, '0');
	let formattedDate = `${parts[0]}-${month}-${day}`;
	return formattedDate;
}

const DefaultAlarmFixModal = observer(
	({ defaultValue, setFixModal, category = 'schedule', onLoad }) => {
		const { alarmStore } = useContext(RootStoreContext);
		const modalRef = useRef(null);
		console.log('defaultValue', defaultValue);
		const [days, setDays] = useState([
			defaultValue?.day[0] || 'x',
			defaultValue?.day[1] || 'x',
			defaultValue?.day[2] || 'x',
			defaultValue?.day[3] || 'x',
			defaultValue?.day[4] || 'x',
			defaultValue?.day[5] || 'x',
			defaultValue?.day[6] || 'x',
		]);
		const [faceUserIds, setFaceUserIds] = useState(
			defaultValue?.face_users?.map((face_user) => face_user.id) || [],
		);
		const [isError, setIsError] = useState(false);
		const [target, setTarget] = useState(defaultValue?.target);

		// 바깥 클릭 시 모달 닫기
		useEffect(() => {
			const handleClickOutside = (event) => {
				if (modalRef.current && !modalRef.current.contains(event.target)) {
					setFixModal(false);
				}
			};

			document.addEventListener('mousedown', handleClickOutside);
			// body 스크롤 잠금
			const prevOverflow = document.body.style.overflow;
			const prevTouch = document.body.style.touchAction;
			document.body.style.overflow = 'hidden';
			document.body.style.touchAction = 'none';
			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
				document.body.style.overflow = prevOverflow;
				document.body.style.touchAction = prevTouch;
			};
		}, [setFixModal]);

		const { register, handleSubmit, setValue } = useForm({
			defaultValues: {
				start_date: formattedDate,
				end_date: formattedDate,
				start_time: defaultValue?.start_time,
				end_time: defaultValue?.end_time,
				days: [
					defaultValue?.day[0] || 'x',
					defaultValue?.day[1] || 'x',
					defaultValue?.day[2] || 'x',
					defaultValue?.day[3] || 'x',
					defaultValue?.day[4] || 'x',
					defaultValue?.day[5] || 'x',
					defaultValue?.day[6] || 'x',
				],
			},
		});

		const toggleDay = (index) => {
			setDays((state) => {
				const tempState = [...state];
				tempState[index] = days[index] === 'o' ? 'x' : 'o';
				return tempState;
			});
		};

		const onSubmit = async (data) => {
			if (
				(target === 'Someone' && faceUserIds.length > 0) ||
				target === 'Anyone'
			) {
				const startDate = formatted(data.start_date) + 'T00:00:00';
				const endDate = formatted(data.end_date) + 'T00:00:00';

				await alarmStore.updateAlarm({
					id: defaultValue.id,
					category,
					name: data.name,
					info: data.name,
					start_date: startDate || formattedDate,
					end_date: endDate || formattedDate,
					start_time: data.start_time,
					end_time: data.end_time,
					time: '00:00',
					day: days.join(''),
					repeat: '5M',
					target: target,
					scenario_id_array: [],
					face_user_id_array: target !== 'Someone' ? faceUserIds : [],
					priority: 150,
					state: true,
				});
				setFixModal(false);
				onLoad();
				setIsError(false);
			} else {
				setIsError(true);
			}
		};

		const onDelete = async (data) => {
			const startDate = data.start_date + 'T00:00:00';
			const endDate = data.end_date + 'T00:00:00';

			await alarmStore.deleteAlarm({
				id: defaultValue.id,
				category,
				name: data.name,
				info: data.name,
				start_date: startDate || formattedDate,
				end_date: endDate || formattedDate,
				start_time: '00:00',
				end_time: '23:59',
				time: data.time || '00:00',
				day: days.join(''),
				repeat: '5M',
				target: 'Someone',
				scenario_id_array: [],
				face_user_id_array: target === 'Someone' ? faceUserIds : [],
				priority: 150,
				state: true,
			});
			setFixModal(false);
			onLoad();
		};

		return (
			<S.Container ref={modalRef}>
				<S.Header>
					<S.CloseButton onClick={() => setFixModal(false)}>+</S.CloseButton>
					<p>알림 설정</p>
					<form onSubmit={handleSubmit(onDelete)}>
						<S.DeleteButton type='submit'>삭제</S.DeleteButton>
					</form>
					<form onSubmit={handleSubmit(onSubmit)}>
						<S.SaveButton type='submit'>수정</S.SaveButton>
					</form>
				</S.Header>
				<S.Content>
					<S.AlarmContent>
						<div className='title'>
							<input
								placeholder='알림 이름을 입력하세요'
								type='text'
								defaultValue={defaultValue?.name}
								{...register('name')}
							/>
						</div>
						<div className='time cell'>
							<div className='content_flex'>
								<p className='cellTitle'>알림 시간</p>
								{/*<div className='switch_wrapper'>*/}
								{/*	<input*/}
								{/*		className='switch_input'*/}
								{/*		type='checkbox'*/}
								{/*		id={'make_modal_switch2'}*/}
								{/*	/>*/}
								{/*	<label*/}
								{/*		htmlFor={'make_modal_switch2'}*/}
								{/*		className='switch_label'>*/}
								{/*		<span className='onf_btn'></span>*/}
								{/*	</label>*/}
								{/*</div>*/}
							</div>
							<div className='timeBox'>
								<CustomTimeInput
									value={defaultValue.start_time}
									onChange={(time) => setValue('start_time', time)}
								/>
								<span>부터</span>
								<CustomTimeInput
									value={defaultValue.end_time}
									onChange={(time) => setValue('end_time', time)}
								/>
								<span>까지</span>
							</div>
						</div>
						<div className='date cell'>
							<div className='content_flex'>
								<p className='cellTitle'>활성화 기간</p>
								{/*<div className='switch_wrapper'>*/}
								{/*	<input*/}
								{/*		className='switch_input'*/}
								{/*		type='checkbox'*/}
								{/*		id={'make_modal_switch1'}*/}
								{/*	/>*/}
								{/*	<label*/}
								{/*		htmlFor={'make_modal_switch1'}*/}
								{/*		className='switch_label'>*/}
								{/*		<span className='onf_btn'></span>*/}
								{/*	</label>*/}
								{/*</div>*/}
							</div>
							<div className='timeBox'>
								<CalendarInput
									value={defaultValue?.start_date?.split('T')[0]}
									onChange={(date) => setValue('start_date', date)}
									placeholder='시작 날짜'
								/>
								<span>부터</span>
								<CalendarInput
									value={defaultValue?.end_date?.split('T')[0]}
									onChange={(date) => setValue('end_date', date)}
									placeholder='종료 날짜'
								/>
								<span>까지</span>
							</div>
							<div className='dayButtons'>
								{['월', '화', '수', '목', '금', '토', '일'].map(
									(day, index) => {
										// const dayValues = watch('days');
										// console.log('dayValues[index]', dayValues[index]);
										return (
											<label
												key={index}
												id={`day_${index}`}
												onClick={() => toggleDay(index)}
												className={days[index] === 'o' ? 'day clicked' : 'day'}>
												{day}
												<input
													id={`day_${index}`}
													key={index}
													type='hidden'
													value={days[index] === 'o' ? 'o' : 'x'}
													{...register(`days[${index}]`)}
												/>
											</label>
										);
									},
								)}
							</div>
						</div>
						<div className='user cell'>
							<div>
								<p className='cellTitle'>
									알림 대상 설정
									{isError && faceUserIds.length <= 0 && (
										<span className='error'>사용자를 선택해주세요.</span>
									)}
									{isError && target === '' && (
										<span className='error'>알림 대상을 설정해주세요.</span>
									)}
								</p>
							</div>
							<div className='userSelect'>
								<div
									className={target === 'Anyone' ? 'clicked' : ''}
									onClick={() => {
										setTarget('Anyone');
									}}>
									인지되는 모든 사람
								</div>
								<div
									className={target === 'Someone' ? 'clicked' : ''}
									onClick={() => {
										setTarget('Someone');
									}}>
									선택된 사람
								</div>
								{target === 'Someone' && (
									<>
										<UserSelectDropdown
											users={alarmStore.users}
											selectedUsers={faceUserIds}
											onUserSelect={(userId) => {
												console.log('userId', userId);
												setTarget('Someone');
												setFaceUserIds((state) => [...state, userId]);
											}}
											placeholder='사용자 선택 +'
										/>
										{faceUserIds.map((user, index) => {
											return (
												<div
													key={index}
													className='alarm-user'
													onClick={() => {
														console.log('userId', user);
														setFaceUserIds((state) =>
															state.filter((item) => item !== user),
														);
													}}>
													{
														alarmStore.users?.filter((alarmUser) => {
															console.log(
																alarmUser,
																alarmUser.id,
																+user,
																alarmUser.id == user,
															);
															return alarmUser.id == user;
														})[0]?.name
													}
												</div>
											);
										})}
									</>
								)}
							</div>
						</div>
					</S.AlarmContent>
				</S.Content>
			</S.Container>
		);
	},
);

export default DefaultAlarmFixModal;
